import "../../styles/WhoWeAre.css";
const VisionMission = () => (
  <section className="vision-mission">
    <div className="section-card">
      <p>
        We are Ponvel Exim – Where Quality Meets Commitment. We are a
        manufacturer-driven export company, built on the principles of trust,
        innovation, and customer satisfaction. At Ponvel Exim, we don’t just
        source – we create, produce, and export. Our vertically integrated
        manufacturing facilities ensure end-to-end quality control and allow us
        to meet global standards. With modern production infrastructure and
        experienced professionals, we cater to both bulk orders and private
        label requirements across the globe.
      </p>
    </div>
  </section>
);
export default VisionMission;
